import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PublicCalendar from './pages/PublicCalendar';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminAnalyze from './pages/AdminAnalyze';
import AdminForm from './pages/AdminForm';
import BibaChat from './pages/BibaChat';
import BibaChatAI from './pages/BibaChatAI';
import Landing from './pages/Landing';
import RandomGenerator from './pages/RandomGenerator';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PublicCalendar />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/random-generator" element={<RandomGenerator />} />
        <Route path="/admin/chat" element={<BibaChat />} />
        <Route path="/admin/chat-ai" element={<BibaChatAI />} />
        <Route path="/admin/analyze" element={<AdminAnalyze />} />
        <Route path="/admin/form" element={<AdminForm />} />
        <Route path="/admin/*" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;









